import React from 'react';
import {
  Page, Section, SectionTitleUnderlined, ExperienceList,
  LineList, SkillsInline, ContactRow
} from './_shared';

/**
 * "Executive" template (key: elegant-serif).
 *
 * Refined serif typography for senior, leadership, finance, law, and
 * traditional industries. Centered name; small caps section headings; no
 * accent color — relies on negative space and typographic hierarchy.
 */

const ACCENT = '#1f1f1f';

const ElegantSerif = ({ data }) => {
  const fontFamily = "'Georgia', 'Cambria', 'Times New Roman', serif";
  return (
    <Page accent={ACCENT} fontFamily={fontFamily} padding="0.85in" style={{ lineHeight: 1.5 }}>
      <header style={{ textAlign: 'center', marginBottom: '0.9rem' }}>
        <h1 style={{
          fontSize: '28pt',
          fontWeight: 400,
          margin: 0,
          letterSpacing: '0.02em',
          color: '#000'
        }}>
          {data.fullName}
        </h1>
        {data.jobTitle && (
          <div style={{
            fontSize: '11pt',
            marginTop: '4px',
            color: '#374151',
            fontStyle: 'italic'
          }}>
            {data.jobTitle}
          </div>
        )}
        <ContactRow data={data} separator=" · " style={{ marginTop: '8px', textAlign: 'center' }} />
      </header>

      <div style={{
        height: '1px',
        background: ACCENT,
        margin: '0 auto 0.75rem',
        width: '40%'
      }} />

      {data.summary && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} letterSpacing="0.18em">Profile</SectionTitleUnderlined>
          <p style={{ margin: 0, fontStyle: 'italic' }}>{data.summary}</p>
        </Section>
      )}

      {data.experience && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} letterSpacing="0.18em">Experience</SectionTitleUnderlined>
          <ExperienceList text={data.experience} accent={ACCENT} />
        </Section>
      )}

      {data.education && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} letterSpacing="0.18em">Education</SectionTitleUnderlined>
          <LineList text={data.education} />
        </Section>
      )}

      {data.skills && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} letterSpacing="0.18em">Areas of Expertise</SectionTitleUnderlined>
          <SkillsInline skills={data.skills} separator=" · " />
        </Section>
      )}

      {data.certifications && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} letterSpacing="0.18em">Credentials</SectionTitleUnderlined>
          <LineList text={data.certifications} />
        </Section>
      )}

      {data.languages && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} letterSpacing="0.18em">Languages</SectionTitleUnderlined>
          <LineList text={data.languages} />
        </Section>
      )}
    </Page>
  );
};

export default ElegantSerif;
